(() => {
  const root = typeof window === 'undefined' ? globalThis : window;
  const active = (start, end, now = Date.now()) => Number.isFinite(start) && Number.isFinite(end) && start <= now && now < end;
  root.EkatoEarlyAccess = { active };
  if (typeof document === 'undefined') return;

  let timer;
  const refresh = () => {
    clearTimeout(timer);
    const now = Date.now();
    let next = Infinity;
    document.querySelectorAll('[data-early-access-window]').forEach((node) => {
      const start = Number(node.dataset.earlyStart);
      const end = Number(node.dataset.earlyEnd);
      const enabled = active(start, end, now);
      if (start > now) next = Math.min(next, start);
      if (end > now) next = Math.min(next, end);
      if (!node.hasAttribute('data-early-access-price')) return;
      const current = node.querySelector('[data-early-current]');
      const value = enabled ? node.dataset.earlySale : node.dataset.earlyBase;
      if (current && current.textContent !== value) current.textContent = value;
      node.querySelectorAll('[data-early-original], [data-early-badge]').forEach((item) => { item.hidden = !enabled; });
    });
    document.dispatchEvent(new CustomEvent('ekato:promotion-refresh'));
    if (Number.isFinite(next)) timer = setTimeout(() => {
      refresh();
      if (Date.now() >= next) root.location.reload();
    }, Math.min(next - now + 25, 2147483647));
  };

  const start = () => {
    refresh();
    new MutationObserver((records) => {
      if (records.some((record) => Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 && (node.matches('[data-early-access-window]') || node.querySelector('[data-early-access-window]'))
      ))) refresh();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
    root.addEventListener('pageshow', refresh);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
